export default function Hero() {
  const statsData = [
    { value: '10万+', label: '高清片库' },
    { value: '每日更新', label: '30+部新片' },
    { value: '全类型', label: '动作科幻喜剧' },
  ];

  return (
    <section
      id="hero"
      className="relative w-full min-h-[580px] md:min-h-[680px] flex items-center overflow-hidden pt-16"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Cinematic%20dark%20theater%20stage%20with%20warm%20amber%20spotlight%20and%20deep%20red%20velvet%20curtains%2C%20golden%20film%20reel%20texture%20floating%2C%20dramatic%20shadow%20play%2C%20luxurious%20movie%20palace%20atmosphere%2C%20rich%20contrast%20lighting%2C%20elegant%20art%20deco%20details%2C%20warm%20golden%20and%20crimson%20tones%2C%20atmospheric%20depth%20with%20soft%20bokeh%20background&width=1600&height=900&seq=hero-66-cinema-01&orientation=landscape"
          alt="六六影院电影观影场景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/35 to-black/60"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-12 md:py-20">
        <div className="w-full max-w-[1280px] mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
            <div className="flex-1 w-full text-center lg:text-left">
              <span className="inline-block px-4 py-1.5 rounded-full bg-accent-500/80 text-background-50 text-xs md:text-sm font-medium tracking-wide mb-5 whitespace-nowrap">
                每日更新 · 极速高清 · 免费观影
              </span>

              <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl text-background-50 leading-tight mb-4">
                六六影院
                <span className="block text-xl md:text-2xl lg:text-3xl font-body font-light mt-2 text-background-50/90">
                  最新高清电影免费在线观看
                </span>
              </h1>

              <p className="text-base md:text-lg text-background-50/80 leading-relaxed mb-4 max-w-[620px] mx-auto lg:mx-0">
                动作、科幻、喜剧全类型一站式观影首选
              </p>

              <p className="text-sm md:text-base text-background-50/70 leading-relaxed mb-7 max-w-[600px] mx-auto lg:mx-0">
                六六影院电影大全汇聚最新上映大片与经典高清电影，涵盖动作、科幻、喜剧全类型片库。
                每日精选更新，无需缓冲即可畅享1080P高清画质，打造专属你的私人影院体验。
              </p>

              <div className="flex flex-wrap items-center justify-center lg:justify-start gap-5 md:gap-8 mb-8">
                {statsData.map((stat) => (
                  <div key={stat.label} className="text-center">
                    <div className="text-xl md:text-2xl font-bold text-primary-400 whitespace-nowrap">
                      {stat.value}
                    </div>
                    <div className="text-xs md:text-sm text-background-50/60 mt-1 whitespace-nowrap">
                      {stat.label}
                    </div>
                  </div>
                ))}
              </div>

              <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
                <a
                  href="#cards"
                  onClick={(e) => {
                    e.preventDefault();
                    document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="inline-flex items-center gap-2 px-8 py-3 rounded-full bg-primary-500 text-foreground-950 font-semibold text-sm md:text-base hover:bg-primary-400 transition-all duration-200 whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-play-circle-line text-lg"></i>
                  开始观影
                </a>
                <a
                  href="#ranking"
                  onClick={(e) => {
                    e.preventDefault();
                    document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="inline-flex items-center gap-2 px-8 py-3 rounded-full border border-background-50/30 text-background-50 font-medium text-sm md:text-base hover:bg-background-50/10 transition-all duration-200 whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-fire-line text-lg"></i>
                  热映榜单
                </a>
              </div>
            </div>

            <div className="flex-1 w-full max-w-[520px] lg:max-w-none">
              <div className="relative aspect-[4/3] rounded-2xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Stacked%20vintage%20movie%20posters%20and%20film%20strips%20floating%20in%20dramatic%20golden%20light%2C%20cinematic%20composition%20with%20warm%20amber%20spotlight%2C%20classic%20film%20reel%20elements%2C%20luxurious%20dark%20background%20with%20velvet%20texture%2C%20rich%20golden%20and%20deep%20red%20color%20palette%2C%20elegant%20movie%20theater%20aesthetic%2C%20dramatic%20shadow%20and%20light%20interplay%2C%20editorial%20quality&width=1200&height=900&seq=hero-66-poster-02&orientation=landscape"
                  alt="六六影院电影海报精选合集"
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent rounded-2xl"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}